import { MediaMatcher } from "@angular/cdk/layout";
import { ChangeDetectorRef, Component, Input, Output, EventEmitter } from "@angular/core";
import { MapHelperService } from "src/services/map-helper.service";
import { PanelAddGeofencesService } from "../../../services/Panel-Add-Geofences.service";
import { Observable, Subscription } from "rxjs";

@Component({
  selector: "buffer-selector",
  templateUrl: "./buffer-selector.component.html",
  styleUrls: ["./buffer-selector.component.css"],
})
export class BufferSelectorComponent {
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

    isVisibleControlSliderRadio = false;
    $isVisibleControlSliderRadio : Observable<boolean> = new Observable<boolean>();


  @Input() fullScreen: boolean;
  @Input() initialRadio: string = "0.1";

  @Output() changedRadio = new EventEmitter<number>();

  bufferButtonMsg: string = "Selecciona un punto en el mapa para crear el centro del buffer, después modifique el radio del círculo";
  isBufferButtonMsgVisible: boolean = false;
  
  subscription_GetSlider: Subscription;
  constructor(
    private panelAddGeofencesService: PanelAddGeofencesService,
    public mapHelperService: MapHelperService,
    changeDetectorRef: ChangeDetectorRef, 
    media: MediaMatcher) {
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit(): void {
    console.log("ngOnInit buffer-selector");
    this.$isVisibleControlSliderRadio = this.panelAddGeofencesService.getVisibleControlSliderRadio();
    this.subscription_GetSlider = this.$isVisibleControlSliderRadio.subscribe((data)=>{
      this.isVisibleControlSliderRadio = data;
    });
  }

  ngOnDestroy(): void {
    console.log("ngOnDestroy buffer-selector");
    
    if (this.subscription_GetSlider)
      this.subscription_GetSlider.unsubscribe();

    this.mapHelperService.removeBufferDrawControl();
    this.panelAddGeofencesService.setVisibleControlSliderRadio(false);
    this.mapHelperService.ResetActiveBuffer();
    this.changedRadio.emit(0);
  }

  onSetBufferCenter() {
    this.isBufferButtonMsgVisible = true;
    // this.mapHelperService.AddBufferGeofenceMode = true;
    // this.mapHelperService.AddPolygonGeofenceMode = false;
    // this.mapHelperService.toggleDrawControl();
    this.mapHelperService.addBufferDrawControl();
    this.panelAddGeofencesService.setVisibleControlSliderRadio(true);
  }

  formatLabel(value: number) {
    if (value >= 1) {
      return value + "km";
    }
    return value;
  }

  onChangeRadio(event) {
    // this.mapHelperService.radioKm = event.value;
    this.mapHelperService.bufferRadioKm = event.value;
    this.changedRadio.emit(event.value);
    this.mapHelperService.UpdateActiveBuffer(
      this.mapHelperService.bufferCenterLat,
      this.mapHelperService.bufferCenterLng,
      this.mapHelperService.bufferRadioKm
    );
  }

  onVisibilityChange(isVisible: boolean) {
    this.isBufferButtonMsgVisible = isVisible;
  }
}
